const messages = {
    accountBox: {
        title: "Pulpit",
        description: "Szybko śledź swoje promocje i punkty.",
        button: "OTWÓRZ PULPIT",
    },
};

export default {
    messages,
};
